import { AxiosResponse } from "axios";

/** Saves a file the API sent as an attachment, under the name it gave. */
export const saveDownload = (response: AxiosResponse<Blob>, fallbackName: string) => {
  const disposition: string = response.headers["content-disposition"] ?? "";
  const fileName = /filename="([^"]+)"/.exec(disposition)?.[1] ?? fallbackName;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
